import { getStyledElement } from "@/helpers";
import { Link } from "react-router-dom";

export const LinkTo = getStyledElement(Link)({
  styles: {
    fontWeight: 700
  }
});
